import React from "react";

import SpinSciSVG from "./SpinSciSVG.svg";

const SpinSciIcon = () => (<img src={SpinSciSVG} alt =''/>);
export default SpinSciIcon;
